import * as React from 'react'
import { Box, Typography, Card, CardContent } from '@alice-financial/pretext-ui'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { OnboardingStepType } from '@alice-financial/alice-sdk'
import { OnboardingStepConfig } from './stepConfiguration'

interface StickyInstructionsProps {
  stepConfig: OnboardingStepConfig | null
  stepType: OnboardingStepType | null
}

/**
 * Sticky instructions component that displays contextual help and guidance
 * for the current onboarding step
 */
export const StickyInstructions = ({ stepConfig, stepType }: StickyInstructionsProps) => {
  if (!stepConfig || !stepType) {
    return (
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          overflow: 'auto',
        }}
      >
        <Typography variant="body2" color="text.secondary" textAlign="center">
          Select a step to view instructions
        </Typography>
      </Box>
    )
  }

  const { Instructions } = stepConfig

  return (
    <Card sx={{ position: 'sticky', top: 0, overflow: 'auto' }}>
      {/* Blue header section */}
      <Box
        sx={{
          backgroundColor: 'info.main',
          p: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <HelpOutlineIcon sx={{ color: 'white', fontSize: '1.25rem' }} />
        <Typography variant="h3" sx={{ color: 'white', mb: 0 }}>
          Instructions
        </Typography>
      </Box>

      {/* Content section */}
      <CardContent>
        <Instructions />
      </CardContent>
    </Card>
  )
}
